import { produce } from 'immer';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type Panels = 'setting' | 'thread' | 'search';

type ControlOpenPanelsState = {
  isOpenThread: boolean;
  isOpenChannelSetting: boolean;
  isOpenSearchPannel: boolean;
  changeOpenThread: (isOpen: boolean) => void;
  changeOpenChannelSettings: (isOpen: boolean) => void;
  changeOpenSearchPannel: (isOpen: boolean) => void;
  openPanel: (panel: Panels) => void;
};

const useControlOpenPanels = create<ControlOpenPanelsState>()(
  devtools((set) => ({
    isOpenThread: false,
    isOpenSearchPannel: false,
    isOpenChannelSetting: false,
    changeOpenThread(isOpen) {
      set(
        produce((draft: ControlOpenPanelsState) => {
          draft.isOpenThread = isOpen;
        }),
      );
    },
    changeOpenChannelSettings(isOpen) {
      set(
        produce((draft: ControlOpenPanelsState) => {
          draft.isOpenChannelSetting = isOpen;
        }),
      );
    },
    changeOpenSearchPannel(isOpen) {
      set(
        produce((draft: ControlOpenPanelsState) => {
          draft.isOpenSearchPannel = isOpen;
        }),
      );
    },
    openPanel(panel) {
      set(
        produce((draft: ControlOpenPanelsState) => {
          if (panel === 'setting') {
            draft.isOpenChannelSetting = true;
            draft.isOpenThread = false;
            draft.isOpenSearchPannel = false;
          }

          if (panel === 'thread') {
            draft.isOpenChannelSetting = false;
            draft.isOpenSearchPannel = false;
            draft.isOpenThread = true;
          }

          if (panel === 'search') {
            draft.isOpenChannelSetting = false;
            draft.isOpenThread = false;
            draft.isOpenSearchPannel = true;
          }
        }),
      );
    },
  })),
);

export default useControlOpenPanels;
